const fr_FR = {
               
}
export default fr_FR;